import React from 'react';
import PropTypes from 'prop-types';
import { BasicForm } from './BasicForm.jsx';

export class SwitchForm extends BasicForm {
  render () {
    const { disabled, input, object: { label } } = this.props;

    return (
      <div className="cu-ui-form-group cu-ui-form-switch">
        <label className="cu-ui-switch">
          <input type="checkbox" {...input} disabled={disabled}/>
          <div className="cu-ui-slider"/>
        </label>
        <span>{ label }</span>
      </div>
    );
  }
}
